import React from 'react'
import { Modal, Backdrop, Fade, Button, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'

const DeletePodcast = ({ open, setOpen, deletePodcast }) => {
  const classes = useStyles()

  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Typography className={classes.title}>
              Are you sure that you want to delete podcast?
            </Typography>
            <Grid className={classes.boxBtnFooter}>
              <Button className={classes.close} onClick={() => setOpen(false)}>CLOSE</Button>
              <Button className={classes.save} onClick={() => deletePodcast()}>DELETE</Button>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

export default DeletePodcast
